// core/action/reportActions.js
import { reportAPI } from './api';
import { toast } from 'react-toastify';

export const reportActions = {
    // Sales Report
    getSalesReport: async (params = {}) => {
        try {
            const response = await reportAPI.sales(params);
            debugger;
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load sales report'
            };
        } catch (error) {
            console.error('Error fetching sales report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load sales report'
            };
        }
    },

    // Purchase Report
    getPurchaseReport: async (params = {}) => {
        try {
            const response = await reportAPI.purchases(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load purchase report'
            };
        } catch (error) {
            console.error('Error fetching purchase report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load purchase report'
            };
        }
    },

    // Inventory Report
    getInventoryReport: async (params = {}) => {
        try {
            const response = await reportAPI.inventory(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load inventory report'
            };
        } catch (error) {
            console.error('Error fetching inventory report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load inventory report'
            };
        }
    },

    // Supplier Report
    getSupplierReport: async (params = {}) => {
        try {
            const response = await reportAPI.suppliers(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load supplier report'
            };
        } catch (error) {
            console.error('Error fetching supplier report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load supplier report'
            };
        }
    },

    // Customer Report
    getCustomerReport: async (params = {}) => {
        try {
            const response = await reportAPI.customers(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load customer report'
            };
        } catch (error) {
            console.error('Error fetching customer report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load customer report'
            };
        }
    },

    // Expense Report
    getExpenseReport: async (params = {}) => {
        try {
            const response = await reportAPI.expenses(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load expense report'
            };
        } catch (error) {
            console.error('Error fetching expense report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load expense report'
            };
        }
    },

    // Income Report
    getIncomeReport: async (params = {}) => {
        try {
            const response = await reportAPI.income(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load income report'
            };
        } catch (error) {
            console.error('Error fetching income report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load income report'
            };
        }
    },

    // Tax Report
    getTaxReport: async (params = {}) => {
        try {
            const response = await reportAPI.tax(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load tax report'
            };
        } catch (error) {
            console.error('Error fetching tax report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load tax report'
            };
        }
    },

    // Profit & Loss Report
    getProfitLossReport: async (params = {}) => {
        try {
            const response = await reportAPI.profitLoss(params);
            if (response.data && response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to load profit & loss report'
            };
        } catch (error) {
            console.error('Error fetching profit & loss report:', error);
            return {
                success: false,
                message: error.message || 'Failed to load profit & loss report'
            };
        }
    },
    // Add to reportActions.js
getOpeningBalanceReport: async (params = {}) => {
    try {
        const response = await reportAPI.openingBalance(params);
        if (response.data && response.success) {
            return {
                success: true,
                data: response.data            };
        }
        return {
            success: false,
            message: response.message || 'Failed to load opening balance report'
        };
    } catch (error) {
        console.error('Error fetching opening balance report:', error);
        return {
            success: false,
            message: error.message || 'Failed to load opening balance report'
        };
    }
},

    // Export to PDF
    exportToPDF: async (reportType, params = {}) => {
        try {
            const response = await reportAPI.exportPDF(reportType, params);
            return response;
        } catch (error) {
            console.error('Error exporting report:', error);
            toast.error('Failed to export report');
            return null;
        }
    },

    // Export to Excel
    exportToExcel: async (reportType, params = {}) => {
        try {
            const response = await reportAPI.exportExcel(reportType, params);
            return response;
        } catch (error) {
            console.error('Error exporting report:', error);
            toast.error('Failed to export report');
            return null;
        }
    },

    // Format currency helper
    formatCurrency: (amount, currency = 'INR') => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    },

    // Format percentage
    formatPercentage: (value) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format((value || 0) / 100);
    },

    // Format date
    formatDate: (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch {
            return dateString;
        }
    },

    // Get report types
    getReportTypes: () => [
        { value: 'sales', label: 'Sales Report', icon: 'TrendingUp' },
        { value: 'purchases', label: 'Purchase Report', icon: 'ShoppingCart' },
        { value: 'inventory', label: 'Inventory Report', icon: 'Package' },
        { value: 'suppliers', label: 'Supplier Report', icon: 'Truck' },
        { value: 'customers', label: 'Customer Report', icon: 'Users' },
        { value: 'expenses', label: 'Expense Report', icon: 'DollarSign' },
        { value: 'income', label: 'Income Report', icon: 'TrendingUp' },
        { value: 'tax', label: 'Tax Report', icon: 'Percent' },
        { value: 'profitloss', label: 'Profit & Loss', icon: 'PieChart' }
    ]
};

export default reportActions;